import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

import { HIGHLIGHT_OPTIONS, HighlightModule } from 'ngx-highlightjs';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core.module';

import { UiVersionStateService } from '@security/authorization/ui-version.state-service';
import { BrowserModule } from '@angular/platform-browser';
import { AppLayoutModule } from './app-layout/app-layout.module';
import { MOBILE_MENU_OVERRIDE_TOKEN } from '../component-library/layout/header/mobile-menu-override.token';
import { MobileOverrideService } from './core/mobile-override.service';
import { MfaSetupModule } from '@auth-n/mfa-setup/mfa-setup.module';

/**
 * Root app module which bootstraps the root component {@link: AppComponent},
 * and which presents the app layout via the {@link: AppLayoutModule} and {@link: AppRoutingModule}.
 */
@NgModule({
  declarations: [
    AppComponent
    // Redirect components are standalone and shouldn't be declared here
  ],

  imports: [
    FormsModule,
    BrowserModule,
    CoreModule,
    AppLayoutModule,
    MfaSetupModule,
    AppRoutingModule,
    HighlightModule
    // Standalone components handle their own imports and don't need to be imported here
  ],
  providers: [
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('highlightjs-line-numbers.js'), // Optional, only if you want the line numbers
        languages: {
          typescript: () => import('highlight.js/lib/languages/typescript'),
          css: () => import('highlight.js/lib/languages/css'),
          xml: () => import('highlight.js/lib/languages/xml')
        }
      }
    },
    {
      provide: MOBILE_MENU_OVERRIDE_TOKEN,
      useFactory: (mobileOverrideService: MobileOverrideService) => mobileOverrideService.createMobileMenuOverride(),
      deps: [MobileOverrideService]
    },
    UiVersionStateService,
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
